module.exports = __webpack_public_path__ + "img/sv114.4638c775.svg";